import $ip from'../../../pip/library/pi-ip/pi-ip.js';

export type t_io_data = Record<string, unknown> | unknown[] | JSON | string;

export const dataRead = $ip.parse.json;

/**
 * we make sure that undefined returns the same as null
 */
export const dataWrite = (s: unknown) => (undefined === s ? 'null' : JSON.stringify(s));
